import React, { createContext, useCallback, useReducer, useRef } from 'react'
import { Slot } from '@radix-ui/react-slot'
import {
  removeElementContainer,
  slideInAnimationElementHeight,
} from './RemoveElementAnimation.css'
import { assignInlineVars } from '@vanilla-extract/dynamic'

export const RemoveElementAnimationContext = createContext(
  {} as {
    triggerAnimation: (callback: () => void) => void
  }
)

type AnimationState = {
  isAnimated: boolean
  animationHasEnded: boolean
}
export const RemoveElementAnimation = ({ children }) => {
  const [state, dispatch] = useReducer(
    (
      state: AnimationState,
      action:
        | { type: 'animation-start'; payload: () => void }
        | { type: 'animation-end' }
    ) => {
      switch (action.type) {
        case 'animation-start':
          return {
            isAnimated: true,
            animationHasEnded: false,
          }
        case 'animation-end':
          return { ...state, animationHasEnded: true }
      }
      return
    },
    { isAnimated: false, animationHasEnded: false }
  )
  const elementRef = useRef<HTMLElement>(null)
  const triggerAnimation = useCallback((callback) => {
    dispatch({ type: 'animation-start', payload: callback })
    // Make sure that we don't show the element after the animation has ended
    // We can't rely on onAnimationEnd for most cases
    // We'll end up with flickering elements on remove from list
    setTimeout(() => {
      dispatch({ type: 'animation-end' })
      callback()
    }, 290)
  }, [])
  return (
    <RemoveElementAnimationContext.Provider value={{ triggerAnimation }}>
      {!state.animationHasEnded ? (
        <Slot
          className={removeElementContainer}
          data-is-animated={state.isAnimated}
          style={assignInlineVars({
            [slideInAnimationElementHeight]: `${elementRef.current?.offsetHeight}px`,
          })}
          ref={elementRef}
        >
          {children}
        </Slot>
      ) : null}
    </RemoveElementAnimationContext.Provider>
  )
}
